import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDarkMode } from '../darkmode/DarkModeContext';

const SubscriptionSteps = () => {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();

  const steps = [
    { id: 1, title: "Daftar Online", icon: "image/daftaronline.png", description: "Isi formulir pendaftaran di website Telnet atau hubungi kami melalui WhatsApp." },
    { id: 2, title: "Cek Ketersediaan", icon: "image/cekketersediaan.png", description: "Tim kami akan mengecek ketersediaan jaringan di area Anda" },
    { id: 3, title: "Instalasi Cepat", icon: "image/instalasicepat.png", description: "Teknisi Telnet akan datang untuk Instalasi di rumah/kantor Anda" },
    { id: 4, title: "Mulai Berselancar", icon: "image/berlangganan.png", description: "Nikmati internet cepat, stabil, dan tanpa batas kuota." }
  ];

  return (
    <div
      className="py-16 bg-cover bg-center transition-colors duration-300"
      style={{
        backgroundImage: `url('https://telnet.net.id/assets/bg.png')`,
        backgroundColor: isDarkMode ? '#111827' : '#F0FFF4',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className={`text-3xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            Tata Cara Berlangganan
          </h2>
          <p className={`text-sm max-w-xl mx-auto ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Ikuti langkah mudah berikut untuk mulai menggunakan layanan Telnet Fiber.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {steps.map((step) => (
            <div
              key={step.id}
              className={`card-base p-5 text-center ${
                isDarkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-100'
              }`}
            >
              <span className={`text-xs font-medium mb-2 block ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                Langkah {step.id}
              </span>
              <div className="flex items-center justify-center mx-auto mb-3">
                <img src={step.icon} alt={step.title} className="object-contain max-w-[120px] w-full h-auto" />
              </div>
              <h3 className={`text-sm font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                {step.title}
              </h3>
              <p className={`text-xs leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button onClick={() => navigate('/produk')} className="btn-primary">
            Mulai Berlangganan Sekarang
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSteps;
